var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "is-table" },
        [
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.holidaysList,
                  "row-class-name": "cursor-pointer",
                  "empty-text": _vm.emptyText,
                },
                on: {
                  "row-click": _vm.onRowClick,
                  "cell-mouse-leave": _vm.onCellMouseLeave,
                  "cell-mouse-enter": _vm.onCellMouseEnter,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "date", label: "FECHA", width: "250" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.date))
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "description", label: "DESCRIPCION" },
                }),
                _vm.isAdminPermission
                  ? _c("el-table-column", {
                      attrs: { width: "130", prop: "options" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.checkShowOptions(scope.row),
                                        expression:
                                          "checkShowOptions(scope.row)",
                                      },
                                    ],
                                    staticClass: "button-menu",
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: { type: "text", size: "mini" },
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onClickEdit(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("Editar")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onClickDelete(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("Eliminar")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        158710331
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }